/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarRegularReport from './calendar-regular-report-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarRegularReport {...validProps} />;
}

SvgComponent.iconName = 'calendarRegularReport';

export const CalendarRegularReportIcon = svgIconWrapper(SvgComponent);
